(() => {
  if (window.customColourGalleryInstalled) return;
  window.customColourGalleryInstalled = true;

  const roots = new Map();
  const normalize = (value) => String(value ?? '').trim().toLocaleLowerCase();

  function selectedColour(root, variant, position) {
    const fromVariant = variant?.options?.[position - 1] ?? variant?.[`option${position}`];
    if (fromVariant != null) return fromVariant;

    const option = root.querySelector(`.product-options--option[data-index="${position - 1}"]`);
    return option?.querySelector('[data-item="radio"]:checked, [data-item="disclosure"]')?.value;
  }

  function firstMediaId(root, variant) {
    const position = Number(root.dataset.colourOptionPosition);
    const firstIds = (root.dataset.colourFirstIds || '').split(',').map(Number);
    if (!position) return firstIds.find((id) => id > 0) || 0;

    const values = JSON.parse(root.dataset.colourOptionValues || '[]');
    const value = selectedColour(root, variant, position);
    const colourIndex = values.findIndex((item) => normalize(item) === normalize(value));

    return firstIds[colourIndex] || firstIds.find((id) => id > 0) || 0;
  }

  function selectMedia(root, mediaId) {
    const mediaSelector = `.product-media--root[data-id="${mediaId}"]`;

    root.querySelectorAll('product-media-variants').forEach((gallery) => {
      if (!gallery.querySelector(mediaSelector)) return;

      if (typeof gallery.updateVariantMedia === 'function') {
        gallery.updateVariantMedia(mediaId);
      } else {
        gallery.querySelectorAll('.product-media--root').forEach((media) => {
          media.dataset.active = String(Number(media.dataset.id) === mediaId);
        });
      }

      gallery.querySelectorAll('product-thumbs-element').forEach((thumbs) => {
        if (typeof thumbs.updateActive === 'function') thumbs.updateActive(mediaId);
      });
    });

    root.querySelectorAll('product-carousel').forEach((carousel) => {
      if (!carousel.querySelector(mediaSelector)) return;

      carousel.querySelectorAll('.product-media--root').forEach((media) => {
        media.dataset.active = String(Number(media.dataset.id) === mediaId);
      });

      if (carousel.offsetWidth && carousel.loaded_size && typeof carousel.goToSlide === 'function') {
        carousel.goToSlide(mediaId);
      }
    });
  }

  function scan() {
    for (const [root, subscription] of roots) {
      if (!root.isConnected) {
        window.removeEventListener(subscription.eventName, subscription.listener);
        roots.delete(root);
      }
    }

    document.querySelectorAll('[data-product-id][data-custom-colour-gallery="true"]').forEach((root) => {
      if (roots.has(root)) return;

      const eventName = `theme:product:${root.dataset.productId}:variantChanged`;
      const listener = (event) => {
        queueMicrotask(() => {
          if (!root.isConnected) return;
          const mediaId = firstMediaId(root, event.detail?.variant);
          if (mediaId) selectMedia(root, mediaId);
        });
      };

      window.addEventListener(eventName, listener);
      roots.set(root, { eventName, listener });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
